import "../../../../src/content/clwc-resources/christian-life-witness-course-resources.scss";
import Videos from "../../../../src/content/clwc-resources/videos.js";
import * as React from 'react';
export default {
  Videos,
  React
};